
function hasContent(value) {
    return (
        typeof value === "string" &&
        Boolean(
            value
                .replace(/<[^>]*>/g, "")
                .replace(/&nbsp;|&#160;|&#x0*a0;/gi, " ")
                .trim(),
        )
    );
}

export default {
    spacingDebug: true,
    components: {
        HeaderTemplate: () => import("~/components/global/templates/HeaderTemplate"),
        IconTemplate: () => import("~/components/global/templates/IconTemplate"),
    },
    props: {
        showHeading: { type: Boolean, default: true },
        payload: { type: Object, default: () => ({}) },
        sectionId: { type: String, default: "accordion" },
    },
    created() {
        this.panelAnimations = new Map();
    },
    beforeDestroy() {
        this.panelAnimations.forEach(({ animation }) => animation.cancel());
        this.panelAnimations.clear();
    },
    methods: {
        togglePanel(event) {
            const summary = event.currentTarget;
            const panel = summary.parentElement;
            const previous = this.panelAnimations.get(panel);
            const opening = previous ? !previous.opening : !panel.open;
            const start = panel.getBoundingClientRect().height;
            if (previous) {
                previous.animation.cancel();
                this.panelAnimations.delete(panel);
            }
            if (!panel.animate) {
                panel.open = opening;
                return;
            }
            panel.open = false;
            const collapsed = panel.getBoundingClientRect().height;
            panel.open = true;
            const expanded = panel.getBoundingClientRect().height;
            const animation = panel.animate([{ height: start + "px" }, { height: (opening ? expanded : collapsed) + "px" }], { duration: 320, easing: "cubic-bezier(0.22, 1, 0.36, 1)" });
            this.panelAnimations.set(panel, { animation, opening });
            animation.onfinish = () => {
                panel.open = opening;
                this.panelAnimations.delete(panel);
                animation.cancel();
            };
        },
    },
    computed: {
        sections() {
            const items = this.payload?.items;
            return Array.isArray(items)
                ? items
                      .filter((item) => hasContent(item?.title))
                      .map((item) => ({
                          ...item,
                          files: Array.isArray(item.files) ? item.files.filter((file) => file?.link || file?.file_path) : [],
                      }))
                      .filter((item) => hasContent(item.html) || item.files.length)
                : [];
        },
        faqs() {
            const faqs = this.payload?.faqs;
            return Array.isArray(faqs) ? faqs.filter((faq) => hasContent(faq?.question) && hasContent(faq?.answer)) : [];
        },
    },
};
